// extracted by mini-css-extract-plugin
export var attachment = "_r8-a";
export var emailContainer = "_r8-4";
export var emailContentPaddedContainer = "_r8-b";
export var emailHeader = "_r8-6";
export var emailIframe = "_r8-3";
export var emailInfoIcon = "_r8-9";
export var emailShortenedSummary = "_r8-e";
export var infoDropdown = "_r8-0";
export var infoRowBoundedContent = "_r8-d";
export var internal = "_r8-5";
export var merchant = "_r8-8";
export var messageInputContainer = "_r8-h";
export var normal = "_r8-7";
export var replyCard = "_r8-f";
export var subtleButton = "_r8-1";
export var subtleButtonIconContainer = "_r8-2";
export var toggleViewRepliesButton = "_r8-c";
export var wrappingText = "_r8-g";